function ExplBox({ans, className}) {
	return (
		<textarea className={className}/>
	);
}

export default ExplBox;